import PropTypes from 'prop-types';

import { Button } from '@utilities';
import { submitFastTrackFeedback } from '@api/fast_tracks';

import FeedbackFooter from '../../../../components/FeedbackFooter';

import {
  negativeFastTrackFeedbackOptions,
  positiveFastTrackFeedbackOptions,
} from './utilities/helpers';

import styles from './_index.module.scss';

const TopicCardFooter = ({
  handleToggleVisbility,
  initialFeedback,
  isExcluded,
  isLoading,
  topicId,
}) => {
  return (
    <div>
      <Button
        className={`${styles['topic-card-footer-exclude-button']}`}
        disabled={isLoading}
        onClick={handleToggleVisbility}
        text={isExcluded ? 'Include' : 'Exclude'}
        variant="secondary"
      />
      <FeedbackFooter
        disabled={isLoading}
        feedbackId={topicId}
        feedbackLabel={'Was this slide helpful?'}
        initialFeedback={initialFeedback}
        negativeFeedbackOptions={negativeFastTrackFeedbackOptions}
        onSubmit={submitFastTrackFeedback}
        positiveFeedbackOptions={positiveFastTrackFeedbackOptions}
      />
    </div>
  );
};

TopicCardFooter.propTypes = {
  handleToggleVisbility: PropTypes.func.isRequired,
  initialFeedback: PropTypes.shape({
    like: PropTypes.bool,
    reason: PropTypes.string,
    reasonExplanation: PropTypes.string,
  }),
  isExcluded: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  topicId: PropTypes.number,
};

export default TopicCardFooter;
